/**
 * WIM Doofinder Search Pricing
 * -----------------------------------------
 * Renderiza precios, ofertas, unidades y disponibilidad para las cards
 * de Doofinder en base al CP / tienda (store_code) del usuario.
 */
(function () {
  'use strict';

  // WIM: Limpiar hash de Doofinder en recarga para evitar scroll al fondo
  // Doofinder usa hashes como #be9b/classic que causan salto de página en recarga
  (function cleanDoofinderHash() {
    try {
      var h = window.location.hash;
      if (h && (h.includes('classic') || h.includes('be9b') || h.includes('mobile') || h.includes('df-'))) {
        history.replaceState(null, document.title, window.location.pathname + window.location.search);
      }
    } catch (e) { }
  })();

  // Monitor e interceptor de peticiones Doofinder
  (function initDoofinderInspector() {
    var origFetch = window.fetch;
    window.fetch = async function () {
      var url = arguments[0];
      var isDf = typeof url === 'string' && (url.includes('doofinder.com') || url.includes('/search'));
      if (isDf) {
        console.group('[WIM Doofinder Inspector] Petición saliente');
        console.log('URL:', url);
        if (arguments[1] && arguments[1].body) {
          console.log('Body:', arguments[1].body);
        }
        console.groupEnd();
      }
      var res = await origFetch.apply(this, arguments);
      if (isDf) {
        try {
          var clone = res.clone();
          var data = await clone.json();
          console.group('[WIM Doofinder Inspector] Respuesta recibida');
          console.log('Total resultados en Doofinder:', data.total || (data.results && data.results.length));
          if (data && data.results && data.results[0]) {
            console.log('Campos indexados en el primer producto:', Object.keys(data.results[0]));
            console.log('Muestra del producto completo:', data.results[0]);
          }
          if (data && data.facets) {
            console.log('Facetas disponibles:', Object.keys(data.facets));
          }
          console.groupEnd();
        } catch (e) { }
      }
      return res;
    };

    var origXhrOpen = XMLHttpRequest.prototype.open;
    var origXhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._dfUrl = url;
      return origXhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (this._dfUrl && typeof this._dfUrl === 'string' && this._dfUrl.includes('doofinder.com')) {
        console.log('[WIM Doofinder Inspector XHR] URL:', this._dfUrl, 'Body:', body);
        this.addEventListener('load', function () {
          try {
            var data = JSON.parse(this.responseText);
            console.group('[WIM Doofinder Inspector XHR] Respuesta');
            if (data && data.results && data.results[0]) {
              console.log('Campos indexados:', Object.keys(data.results[0]));
              console.log('Muestra:', data.results[0]);
            }
            console.groupEnd();
          } catch (e) { }
        });
      }
      return origXhrSend.apply(this, arguments);
    };
  })();

  var CARD_SELECTOR = '[data-wim-df-card]';
  var STOREFRONT_API_VERSION = '2024-10';

  function getCartUrl() {
    return (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart';
  }

  var cachedCartState = null;
  var cartStatePromise = null;
  var pricingCache = {};

  async function getCartState(forceRefresh) {
    if (!forceRefresh && cachedCartState) {
      return cachedCartState;
    }
    if (cartStatePromise) {
      return cartStatePromise;
    }

    var localCp = localStorage.getItem('wim_postal_code');
    var localValid = localStorage.getItem('wim_postal_code_valid');
    var assortmentSc = window.WIM_ASSORTMENT && window.WIM_ASSORTMENT.sc;
    var assortmentPc = window.WIM_ASSORTMENT && window.WIM_ASSORTMENT.pc;

    // Si ya tenemos datos en localStorage o WIM_ASSORTMENT, establecer un fallback inicial rápido
    var initialPostalCode = localCp || assortmentPc || null;
    var initialValid = localValid === 'true' || (Boolean(initialPostalCode) && String(initialPostalCode).trim().length === 5);
    var initialStoreCode = assortmentSc || null;

    cartStatePromise = (async function () {
      try {
        var res = await fetch(getCartUrl() + '.js?t=' + Date.now(), { cache: 'no-store' });
        var cart = await res.json();
        var attrs = cart.attributes || {};
        var postalCode = attrs.postal_code || initialPostalCode;
        var isValid =
          attrs.postal_code_valid === 'true' ||
          attrs.postal_code_valid === true ||
          initialValid;
        var storeCode = attrs.store_code || initialStoreCode;

        cachedCartState = {
          postalCode: postalCode,
          postalCodeValid: isValid,
          storeCode: storeCode
        };
      } catch (err) {
        cachedCartState = {
          postalCode: initialPostalCode,
          postalCodeValid: initialValid,
          storeCode: initialStoreCode
        };
      } finally {
        cartStatePromise = null;
      }
      return cachedCartState;
    })();

    return cartStatePromise;
  }

  // Sincronizar dinámicamente el filtro available_stores con Doofinder
  document.addEventListener('df:request', function (e) {
    if (e.detail && e.detail.params) {
      var sc = (cachedCartState && cachedCartState.storeCode) || localStorage.getItem('wim_store_code');
      if (!sc && window.WIM_ASSORTMENT) sc = window.WIM_ASSORTMENT.sc;
      if (sc) {
        e.detail.params.filter = e.detail.params.filter || {};
        e.detail.params.filter.available_stores = [sc];
      }
    }
  });

  // Invalidar caché de carrito si el usuario actualiza el CP o carrito
  document.addEventListener('wim:postal-code:updated', function () {
    cachedCartState = null;
    pricingCache = {};
    var sc = localStorage.getItem('wim_store_code') || (window.WIM_ASSORTMENT && window.WIM_ASSORTMENT.sc);
    if (sc) {
      if (window.dfClassicLayers && window.dfClassicLayers[0]) {
        window.dfClassicLayers[0].searchParams = window.dfClassicLayers[0].searchParams || {};
        window.dfClassicLayers[0].searchParams.filter = window.dfClassicLayers[0].searchParams.filter || {};
        window.dfClassicLayers[0].searchParams.filter.available_stores = [sc];
      }
      if (window.dfFullscreenLayers && window.dfFullscreenLayers[0]) {
        window.dfFullscreenLayers[0].searchParams = window.dfFullscreenLayers[0].searchParams || {};
        window.dfFullscreenLayers[0].searchParams.filter = window.dfFullscreenLayers[0].searchParams.filter || {};
        window.dfFullscreenLayers[0].searchParams.filter.available_stores = [sc];
      }
    }
    syncStoreFilterWithDoofinder();
    syncStoresFacetAndSelection();
    handleDoofinderUpdate();
  });
  document.addEventListener('cart:updated', function () {
    document.querySelectorAll('[data-wim-df-card] .wim-product-card__atc.btn--loading').forEach(function (btn) { btn.classList.remove('btn--loading'); });
    cachedCartState = null;
  });

  function moneyFormat(cents) {
    var fmt = window.FoxTheme && FoxTheme.settings && FoxTheme.settings.moneyFormat;
    if (typeof cents !== 'number') cents = Number(cents) || 0;
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && fmt) {
      return Shopify.formatMoney(cents, fmt);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function getCardHandle(card) {
    var handle = card.getAttribute('data-handle') || card.getAttribute('data-product-handle');
    if (!handle) {
      // Intentar leer el dfd-value-link en Doofinder V8 (ej: "/products/agua-teleno")
      var dfLink = card.getAttribute('dfd-value-link') || (card.querySelector('[dfd-value-link]') && card.querySelector('[dfd-value-link]').getAttribute('dfd-value-link'));
      if (dfLink) {
        var match = dfLink.match(/\/products\/([a-zA-Z0-9\-_]+)/);
        if (match && match[1]) handle = match[1];
      }
    }
    if (!handle) {
      var wl = card.querySelector('.wishlist-element, .wishlist-element-product');
      if (wl) handle = wl.getAttribute('handler');
    }
    if (!handle) {
      var link = card.querySelector('a[href*="/products/"]');
      if (link) {
        var href = link.getAttribute('href') || link.pathname;
        var match = href.match(/\/products\/([a-zA-Z0-9\-_]+)/);
        if (match && match[1]) {
          handle = match[1];
        }
      }
    }
    if (handle && handle.indexOf('/') !== -1) {
      handle = handle.split('/products/').pop().split('?')[0].replace(/^\/+|\/+$/g, '');
    }
    return handle || null;
  }

  var htmlCache = {};

  async function fetchProductCardHTML(handle) {
    if (htmlCache[handle]) return htmlCache[handle];
    try {
      var res = await fetch('/products/' + handle + '?view=wim-card');
      if (res.ok) {
        var html = await res.text();
        htmlCache[handle] = html;
        return html;
      }
    } catch (e) {
      console.warn('[WimDoofinderPricing] Error fetching HTML for ' + handle, e);
    }
    return null;
  }

  function getDoofinderGridItem(card) {
    // En Doofinder V8 LiveView, las tarjetas están envueltas en un contenedor con data-phx-stream o dentro de .dfd-results-grid
    var directGridItem = card.closest('[data-phx-stream], [id^="results__"], .dfd-card-live');
    if (directGridItem) return directGridItem;

    var dfResults = card.closest('df-results, .df-results, .dfd-results-grid, [data-role="results"], .df-grid, .df-cards-grid, [class*="results"], [class*="grid"]');
    if (dfResults) {
      var cur = card;
      while (cur.parentElement && cur.parentElement !== dfResults) {
        cur = cur.parentElement;
      }
      return cur;
    }
    return card.closest('df-card, .df-card, li, .df-results__item, .df-grid__item') || card.parentElement || card;
  }

  var pending = false;
  var hasQueuedUpdate = false;

  var WISHLIST_OUTLINE_SVG = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-wishlist-outline"><rect width="28" height="28" rx="14" fill="#F1F9FD"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.015 7C19.1823 7.00002 20.1685 7.39705 20.9646 8.1912C21.7607 8.98515 22.1587 9.96859 22.1588 11.1327C22.1587 12.6721 21.5091 14.144 20.2293 15.5452C18.9625 16.9322 17.5761 18.3064 16.0704 19.6674L15.0554 20.5803C14.9124 20.7228 14.7441 20.8294 14.5511 20.8983C14.3626 20.9657 14.173 21 13.9834 21C13.7937 21 13.6063 20.9656 13.4228 20.8978C13.2372 20.8293 13.0734 20.7244 12.9321 20.5848L11.908 19.6629C10.3177 18.2219 8.91345 16.8192 7.69578 15.4562C6.46601 14.0794 5.84185 12.6373 5.8418 11.1327C5.84184 9.96859 6.2399 8.98515 7.03602 8.1912C7.83209 7.39707 8.8183 7.00004 9.98558 7C10.6586 7.00002 11.3553 7.16981 12.0736 7.50426C12.7646 7.82594 13.4061 8.41197 14.0005 9.25005C14.5951 8.41188 15.2363 7.82588 15.9275 7.50426C16.6458 7.16981 17.342 7.00001 18.015 7ZM18.015 8.14742C17.34 8.14742 16.7263 8.32322 16.1711 8.67432C15.6171 9.02448 15.0744 9.61861 14.5461 10.4684C14.4871 10.5675 14.4053 10.6439 14.303 10.6949L14.3035 10.6954C14.207 10.7437 14.1055 10.7688 14.0005 10.7689C13.9218 10.7689 13.8448 10.7546 13.7705 10.7271L13.6971 10.6954C13.5948 10.6444 13.5135 10.5675 13.4545 10.4684C12.9262 9.61869 12.3834 9.02447 11.8295 8.67432C11.2743 8.32331 10.6604 8.14744 9.98558 8.14742C9.12549 8.14746 8.41567 8.43203 7.84676 8.99942C7.27784 9.56684 6.99227 10.2749 6.99223 11.1327C6.99227 11.7647 7.17156 12.418 7.53625 13.0934C7.90367 13.7742 8.39878 14.4742 9.02236 15.193C9.64734 15.9132 10.3661 16.651 11.1793 17.4058C11.9946 18.1626 12.8434 18.9417 13.7258 19.7429L13.7877 19.7887C13.8512 19.8279 13.9215 19.847 14.0005 19.847C14.1057 19.847 14.1951 19.8131 14.2743 19.7429C15.1567 18.9416 16.0059 18.1626 16.8213 17.4058C17.6345 16.651 18.3537 15.9132 18.9787 15.193C19.6023 14.4742 20.0969 13.7742 20.4643 13.0934C20.829 12.418 21.0083 11.7647 21.0083 11.1327C21.0083 10.2749 20.7227 9.56683 20.1538 8.99942C19.5849 8.43206 18.8751 8.14744 18.015 8.14742Z" fill="#004B87"/></svg>';
  var WISHLIST_FILLED_SVG = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-wishlist-filled"><rect width="28" height="28" rx="14" fill="#F1F9FD"/><path d="M18.015 7C19.1823 7.00002 20.1685 7.39705 20.9646 8.1912C21.7607 8.9851 22.1587 9.9686 22.1588 11.1327C22.1587 12.6721 21.5091 14.144 20.2293 15.5452C18.9625 16.9322 17.5761 18.3064 16.0704 19.6674L15.0554 20.5803C14.9124 20.7228 14.7441 20.8294 14.5511 20.8983C14.3626 20.9657 14.173 21 13.9834 21C13.7937 21 13.6063 20.9656 13.4228 20.8978C13.2372 20.8293 13.0734 20.7244 12.9321 20.5848L11.908 19.6629C10.3177 18.2219 8.9134 16.8192 7.6958 15.4562C6.466 14.0794 5.8418 12.6373 5.8418 11.1327C5.8418 9.9686 6.2399 8.9851 7.036 8.1912C7.8321 7.3971 8.8183 7 9.9856 7C10.6586 7 11.3553 7.1698 12.0736 7.5043C12.7646 7.8259 13.4061 8.412 14.0005 9.25C14.5951 8.4119 15.2363 7.8259 15.9275 7.5043C16.6458 7.1698 17.342 7 18.015 7Z" fill="#004B87"/></svg>';

  function isHandleInWishlist(handle) {
    if (!handle) return false;
    if (window.WimWishlists && typeof window.WimWishlists.isInAnyList === 'function') {
      return window.WimWishlists.isInAnyList(handle);
    }
    try {
      var raw = localStorage.getItem('wim_wishlists_multi');
      if (raw) {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          for (var i = 0; i < parsed.length; i++) {
            if (parsed[i].items && parsed[i].items.some(function (it) { return it.h === handle; })) {
              return true;
            }
          }
        }
      }
      var cookieMatch = document.cookie.split('; ').find(function (c) { return c.startsWith('shopify_wishlist='); });
      if (cookieMatch) {
        var handles = cookieMatch.split('=')[1].split(',').filter(Boolean);
        return handles.indexOf(handle) !== -1;
      }
    } catch (e) { }
    return false;
  }

  function syncAllWishlists() {
    var cards = document.querySelectorAll(CARD_SELECTOR + ', .dfd-card, [data-dfd-role="card"]');
    cards.forEach(function (card) {
      var allWls = card.querySelectorAll('.wishlist-element, .wishlist-element-product');
      if (allWls.length > 1) {
        for (var i = 1; i < allWls.length; i++) {
          allWls[i].remove();
        }
      }

      var wl = card.querySelector('.wishlist-element, .wishlist-element-product');
      if (!wl) return;

      var handle = getCardHandle(card);
      if (handle) {
        wl.setAttribute('handler', handle);
      }

      if (!wl.querySelector('svg[viewBox="0 0 28 28"]') || wl.querySelectorAll('svg').length !== 2) {
        wl.innerHTML = WISHLIST_OUTLINE_SVG + WISHLIST_FILLED_SVG;
      }

      var isSaved = isHandleInWishlist(handle);
      wl.classList.toggle('active', isSaved);
    });
  }

  function normalizeWishlistElements(cards) {
    syncAllWishlists();
    if (typeof window.wimSetupWishlistElements === 'function') {
      window.wimSetupWishlistElements();
    }
  }

  function hookWimWishlists() {
    if (window.WimWishlists && !window.WimWishlists._dfHooked) {
      window.WimWishlists._dfHooked = true;
      var origRefresh = window.WimWishlists.refreshHeartStates;
      window.WimWishlists.refreshHeartStates = function () {
        if (typeof origRefresh === 'function') {
          origRefresh.apply(this, arguments);
        }
        syncAllWishlists();
      };
    }
  }
  hookWimWishlists();
  document.addEventListener('DOMContentLoaded', hookWimWishlists);

  var isMutatingDom = false;

  function fixCarouselContainerHeights() {
    document.querySelectorAll('.dfd-carousel-content, .dfd-carousel, .dfd-results-grid, .dfd-results, .dfd-results-block, .dfd-results-column').forEach(function (el) {
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('min-height', '0', 'important');
      el.style.setProperty('max-height', 'none', 'important');
    });
  }

  function hideDoofinderProduct(card) {
    if (!card) return;
    card.classList.add('wim-product-hidden');
    card.style.setProperty('display', 'none', 'important');
    card.style.setProperty('visibility', 'hidden', 'important');
    card.style.setProperty('height', '0', 'important');
    card.style.setProperty('max-height', '0', 'important');
    card.style.setProperty('margin', '0', 'important');
    card.style.setProperty('padding', '0', 'important');
    card.style.setProperty('pointer-events', 'none', 'important');

    var gridItem = getDoofinderGridItem(card);
    if (gridItem) {
      gridItem.classList.add('wim-product-hidden');
      gridItem.style.setProperty('display', 'none', 'important');
      gridItem.style.setProperty('visibility', 'hidden', 'important');
      gridItem.style.setProperty('height', '0', 'important');
      gridItem.style.setProperty('max-height', '0', 'important');
      gridItem.style.setProperty('margin', '0', 'important');
      gridItem.style.setProperty('padding', '0', 'important');
      gridItem.style.setProperty('pointer-events', 'none', 'important');
    }
  }

  function renderSoldOut(priceSlot, actionsSlot, card) {
    if (priceSlot) {
      priceSlot.hidden = true;
      priceSlot.innerHTML = '';
    }
    if (actionsSlot) {
      actionsSlot.innerHTML =
        '<button type="button" class="wim-product-card__atc btn" disabled>' +
        (window.WimDoofinderPricing?.i18n?.soldOut || 'Agotado') +
        '</button>';
    }
    if (card) {
      var gridItem = getDoofinderGridItem(card);
      if (gridItem) {
        gridItem.style.order = '999';
      }
    }
  }

  function renderSeePrice(card) {
    card.style.display = ''; card.setAttribute('data-wim-pricing-rendered', 'see-price'); var gridItem = getDoofinderGridItem(card); if (gridItem) gridItem.style.position = 'relative';
    var priceSlot = card.querySelector('[data-wim-df-price]');
    var actionsSlot = card.querySelector('[data-wim-df-actions]');
    if (priceSlot) {
      priceSlot.hidden = true;
      priceSlot.innerHTML = '';
    }
    if (actionsSlot) {
      actionsSlot.innerHTML =
        '<button type="button" class="wim-product-card__atc btn see-price" data-wim-df-see-price>' +
        '<span>' + (window.WimDoofinderPricing?.i18n?.showPrice || 'Ver precio') + '</span>' +
        '</button>';
    }
  }

  function applyFetchedCard(card, handle, html) {
    if (card.dataset.wimPricingRendered === handle) return;
    card.dataset.wimPricingRendered = handle;

    var gridItem = getDoofinderGridItem(card);
    gridItem.style.display = '';
    gridItem.style.position = 'relative';
    gridItem.style.transform = 'none';
    gridItem.style.top = 'auto';
    gridItem.style.left = 'auto';
    gridItem.style.height = '';
    gridItem.style.minHeight = '';
    gridItem.style.maxHeight = '';
    gridItem.style.margin = '';
    gridItem.style.padding = '';
    gridItem.style.visibility = '';
    gridItem.style.order = '0';
    gridItem.classList.remove('wim-product-hidden');
    card.classList.remove('wim-product-hidden');

    var priceSlot = card.querySelector('[data-wim-df-price]');
    var actionsSlot = card.querySelector('[data-wim-df-actions]');

    if (!html) {
      hideDoofinderProduct(card);
      return;
    }

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var wimCard = doc.querySelector('.wim-product-card, .wim-product-card-custom');

    if (!wimCard || wimCard.classList.contains('wim-product-hidden')) {
      hideDoofinderProduct(card);
      return;
    }

    var priceContainer = wimCard.querySelector('.wim-promotions-wrapper, .wim-product-card__price-container');
    var actionsContainer = wimCard.querySelector('.wim-product-card__actions, .wim-product-card-custom__actions');

    var isSeePrice = actionsContainer && actionsContainer.querySelector('.see-price');
    var userHasValidZip = cachedCartState && cachedCartState.postalCodeValid;

    if (isSeePrice && userHasValidZip) {
      hideDoofinderProduct(card);
      return;
    }

    if (priceSlot) {
      priceSlot.hidden = !priceContainer;
      priceSlot.innerHTML = priceContainer ? priceContainer.outerHTML : '';
    }

    if (actionsSlot) {
      if (actionsContainer) {
        actionsSlot.innerHTML = actionsContainer.innerHTML;

      } else {
        renderSoldOut(null, actionsSlot, card);
      }
    }

    var existingOverlays = card.querySelectorAll('.wim-product-card__alergenos, .wim-product-badges');
    for (var i = 0; i < existingOverlays.length; i++) {
      existingOverlays[i].remove();
    }
    var newAlergenos = wimCard.querySelectorAll('.wim-product-card__alergenos');
    for (var k = 0; k < newAlergenos.length; k++) {
      card.appendChild(newAlergenos[k].cloneNode(true));
    }
    var newBadges = wimCard.querySelectorAll('.wim-product-badges');
    for (var j = 0; j < newBadges.length; j++) {
      card.appendChild(newBadges[j].cloneNode(true));
    }

    var cardLink = card.querySelector('a.dfd-card-link, [data-dfd-role="card-link"]');
    if (cardLink && cardLink.getAttribute('href') && cardLink.getAttribute('href').startsWith('http')) {
      try {
        var u = new URL(cardLink.getAttribute('href'));
        cardLink.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) { }
    }
  }

  async function handleDoofinderUpdate() {
    if (pending) {
      hasQueuedUpdate = true;
      return;
    }
    var cards = document.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return;
    pending = true;

    try {
      isMutatingDom = true;
      normalizeWishlistElements(cards);
      fixCarouselContainerHeights();

      var state = await getCartState();

      if (!state.postalCodeValid) {
        cards.forEach(renderSeePrice);
        return;
      }

      var missingHandles = [];
      var cardsToUpdate = [];

      cards.forEach(function (card) {
        var handle = getCardHandle(card);
        if (!handle) return;

        cardsToUpdate.push({ card: card, handle: handle });

        if (typeof htmlCache[handle] === 'undefined' && missingHandles.indexOf(handle) === -1) {
          missingHandles.push(handle);
        }
      });

      if (missingHandles.length) {
        await Promise.all(missingHandles.map(fetchProductCardHTML));
      }

      cardsToUpdate.forEach(function (item) {
        var html = htmlCache[item.handle];
        applyFetchedCard(item.card, item.handle, html);
      });

      if (window.wimPromotions && typeof window.wimPromotions.refreshAll === 'function') {
        window.wimPromotions.refreshAll();
      }

      cards.forEach(function (card) {
        var allWls = card.querySelectorAll('.wishlist-element, .wishlist-element-product');
        if (allWls.length > 1) {
          for (var i = 1; i < allWls.length; i++) {
            allWls[i].remove();
          }
        }
      });

      if (typeof window.wimSetupWishlistElements === 'function') {
        window.wimSetupWishlistElements();
      }
    } catch (err) {
      console.error('[WimDoofinderPricing] Error al actualizar cards:', err);
    } finally {
      isMutatingDom = false;
      pending = false;
      if (hasQueuedUpdate) {
        hasQueuedUpdate = false;
        setTimeout(handleDoofinderUpdate, 20);
      }
      scheduleSyncUI();
    }
  }

  var isAutoSelectingStore = false;
  var storeSyncDone = false;
  var lastSyncedStoreCode = '';

  function getActiveStoreCode() {
    var sc = (cachedCartState && cachedCartState.storeCode) || localStorage.getItem('wim_store_code');
    if (!sc && window.WIM_ASSORTMENT && window.WIM_ASSORTMENT.sc) {
      sc = window.WIM_ASSORTMENT.sc;
    }
    if (!sc) {
      try {
        var rawAssort = localStorage.getItem('wim_assortment');
        if (rawAssort) sc = JSON.parse(rawAssort).sc || '';
      } catch (e) { }
    }
    return sc || '';
  }

  function findStoresFacet() {
    // 1. Buscar por título de la faceta
    var titles = document.querySelectorAll('.dfd-facet-title, button.dfd-facet-title, [class*="facet-title"]');
    for (var i = 0; i < titles.length; i++) {
      var text = (titles[i].textContent || '').trim().toLowerCase();
      if (text === 'stores' || text.startsWith('stores') || text.includes('tienda')) {
        return titles[i].closest('.dfd-facet') || titles[i].closest('[class*="facet"]') || titles[i].parentElement;
      }
    }
    // 2. Buscar por contenido de botones con códigos de tienda (O990..O999)
    var termBtns = document.querySelectorAll('.dfd-btn-term-filter, button.dfd-btn-term-filter, [class*="btn-term-filter"]');
    for (var j = 0; j < termBtns.length; j++) {
      var btnText = (termBtns[j].textContent || '').trim();
      if (/^O99\d/i.test(btnText)) {
        return termBtns[j].closest('.dfd-facet') || termBtns[j].closest('[class*="facet"]') || termBtns[j].parentElement;
      }
    }
    return null;
  }

  function syncStoresFacetAndSelection() {
    var activeSc = getActiveStoreCode();
    if (!activeSc) return;
    if (storeSyncDone && lastSyncedStoreCode === activeSc) return;
    if (isAutoSelectingStore) return;

    var facetEl = findStoresFacet();
    if (!facetEl) return;

    // Ocultar visualmente la faceta técnica en la interfaz
    if (!facetEl.classList.contains('wim-facet-hidden')) {
      facetEl.classList.add('wim-facet-hidden');
    }
    facetEl.style.setProperty('display', 'none', 'important');

    // Buscar opciones de tiendas dentro de la faceta
    var buttons = facetEl.querySelectorAll('.dfd-btn-term-filter, button, [class*="btn-term-filter"]');
    if (!buttons || buttons.length === 0) return;

    var targetBtn = null;
    var otherSelectedBtns = [];

    for (var k = 0; k < buttons.length; k++) {
      var btn = buttons[k];
      var text = (btn.textContent || '').trim();
      var isSelected = btn.classList.contains('dfd-is-selected') || btn.getAttribute('aria-checked') === 'true';

      if (text.toUpperCase().includes(activeSc.toUpperCase())) {
        targetBtn = btn;
      } else if (isSelected && /^O99\d/i.test(text)) {
        otherSelectedBtns.push(btn);
      }
    }

    // Desmarcar tiendas anteriores que ya no correspondan al CP activo
    if (otherSelectedBtns.length > 0) {
      isAutoSelectingStore = true;
      otherSelectedBtns[0].click();
      setTimeout(function () {
        isAutoSelectingStore = false;
        syncStoresFacetAndSelection();
      }, 400);
      return;
    }

    // Activar la tienda activa si no está seleccionada
    if (targetBtn) {
      var isTargetSelected = targetBtn.classList.contains('dfd-is-selected') || targetBtn.getAttribute('aria-checked') === 'true';
      if (!isTargetSelected) {
        isAutoSelectingStore = true;
        targetBtn.click();
        setTimeout(function () {
          isAutoSelectingStore = false;
          storeSyncDone = true;
          lastSyncedStoreCode = activeSc;
        }, 500);
      } else {
        storeSyncDone = true;
        lastSyncedStoreCode = activeSc;
      }
    }
  }

  function syncStoreFilterWithDoofinder() {
    var sc = getActiveStoreCode();
    if (!sc) return;

    var hash = window.location.hash;
    if (hash && (hash.includes('#be9b/classic') || hash.includes('#be9b/mobile'))) {
      if (!hash.includes('f[available_stores]')) {
        window.location.hash = hash + '&f[available_stores][]=' + encodeURIComponent(sc);
      } else if (!hash.includes(sc)) {
        var updatedHash = hash.replace(/&?f\[available_stores\]\[\]=[^&]*/g, '');
        window.location.hash = updatedHash + '&f[available_stores][]=' + encodeURIComponent(sc);
      }
    }
  }

  window.addEventListener('hashchange', function () {
    syncStoreFilterWithDoofinder();
    syncStoresFacetAndSelection();
  });
  document.addEventListener('doofinder.layer.open', function () {
    syncStoreFilterWithDoofinder();
    syncStoresFacetAndSelection();
    handleDoofinderUpdate();
  });
  document.addEventListener('doofinder.layer.update', function () {
    handleDoofinderUpdate();
  });
  document.addEventListener('doofinder.carousel.load', function () {
    handleDoofinderUpdate();
  });
  document.addEventListener('doofinder.layer.render', function () {
    handleDoofinderUpdate();
  });

  document.addEventListener('wim-wishlists:updated', function () {
    syncAllWishlists();
    if (typeof window.wimSetupWishlistElements === 'function') {
      window.wimSetupWishlistElements();
    }
  });
  document.addEventListener('wim-wishlists:handles-resolved', function () {
    syncAllWishlists();
    if (typeof window.wimSetupWishlistElements === 'function') {
      window.wimSetupWishlistElements();
    }
  });
  document.addEventListener('shopify-wishlist:updated', function () {
    syncAllWishlists();
    if (typeof window.wimSetupWishlistElements === 'function') {
      window.wimSetupWishlistElements();
    }
  });

  // WIM: Títulos de sección de Doofinder con el estilo del sitio (primera palabra normal, resto en bold)

  function formatDoofinderSectionTitles() {
    var titles = document.querySelectorAll('.dfd-initial-content .dfd-content-header .dfd-meta .dfd-title-sm[aria-level="3"]:not([data-wim-title-formatted])');
    titles.forEach(function (title) {
      var words = (title.textContent || '').trim().split(/\s+/);
      if (words.length < 2) return;
      title.setAttribute('data-wim-title-formatted', 'true');
      title.textContent = words[0] + ' ';
      var strong = document.createElement('strong');
      strong.textContent = words.slice(1).join(' ');
      title.appendChild(strong);
    });
  }

  function syncMobileFiltersOpen() {
    var root = document.querySelector('.dfd-root');
    if (!root) return;
    // Solo actuar si el panel lateral de filtros móviles está realmente abierto y visible
    var isAsideOpen = root.classList.contains('dfd-aside-open') ||
    root.querySelector('.dfd-filters-layer:not(.hidden), .dfd-aside--open, [data-dfd-aside-open], .dfd-aside-visible');
    if (!isAsideOpen) return;

    var clearBtn = Array.from(root.querySelectorAll('button, a')).find(function (btn) {
      return /^Limpiar filtros$/i.test((btn.textContent || '').trim());
    });
    if (!clearBtn) return;
    var footer = clearBtn.closest('.dfd-aside-footer, .wim-dfd-filters-footer') || clearBtn.parentElement;
    if (!footer) return;
    if (!footer.querySelector('.wim-dfd-show-results')) {
      var toggle = root.querySelector('.dfd-toggle-filters-button');
      var showResults = document.createElement('button');
      showResults.type = 'button';
      showResults.className = 'dfd-close-filters-button wim-dfd-show-results';
      showResults.setAttribute('dfd-click', 'hide-filters');
      showResults.textContent = 'Mostrar resultados';
      showResults.addEventListener('click', function () {
        if (toggle) toggle.click();
      });
      footer.appendChild(showResults);
    }
  }

  var syncUITimer = null;
  function scheduleSyncUI() {
    if (syncUITimer) return;
    syncUITimer = setTimeout(function () {
      syncUITimer = null;
      if (isMutatingDom) { scheduleSyncUI(); return; }
      isMutatingDom = true;
      try {
        formatDoofinderSectionTitles();
        syncMobileFiltersOpen();
      } finally {
        isMutatingDom = false;
      }
    }, 150);
  }

  var debounceTimer;
  var observer = new MutationObserver(function (mutations) {
    if (isMutatingDom) return;

    var hasNewCards = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var el = added[j];
        if (el.nodeType === 1) {
          if (el.classList.contains('wim-promotions-wrapper') || el.closest('.wim-promotions-wrapper')) continue;
          if (el.matches(CARD_SELECTOR) || el.querySelector(CARD_SELECTOR)) {
            hasNewCards = true;
            break;
          }
        }
      }
      if (hasNewCards) break;
    }

    if (hasNewCards) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(handleDoofinderUpdate, 120);
      scheduleSyncUI();
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  // No inyecta DOM — la × es CSS ::after. Inmune a Morphdom.
  // ATC en cards de Doofinder: mostrar spinner y enviar formulario
  document.addEventListener('click', function (e) {

    var atcBtn = e.target.closest('.wim-product-card__atc');
    if (atcBtn && e.target.closest('[data-wim-df-card]')) {
      e.preventDefault();
      e.stopPropagation();
      // Mostrar spinner igual que en PLP
      atcBtn.classList.add('btn--loading');
      var spinner = atcBtn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
      var form = atcBtn.closest('form');
      if (form) {
        // requestSubmit() dispara el evento nativo de submit con el submitter correcto
        // que FoxTheme product-form necesita; fallback a dispatchEvent
        try {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(atcBtn);
          } else {
            form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          }
        } catch (err) {
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      }
    }
    var seePriceBtn = e.target.closest('[data-wim-df-see-price]');
    if (seePriceBtn) {
      if (typeof window.openLocationPopupFromTrigger === 'function') {
        window.openLocationPopupFromTrigger();
      } else {
        var popup = document.querySelector('location-popup');
        if (popup && typeof popup.show === 'function') {
          popup.show();
        } else {
          var headerLoc = document.querySelector('.header__location-button, .wim-header-location, [data-open-location-popup]');
          if (headerLoc) headerLoc.click();
        }
      }
      return;
    }

    var card = e.target.closest('[data-wim-df-card], .dfd-card');
    if (card) {
      var isInteractive = e.target.closest(
        'button, input, select, .wim-product-card__actions, .wim-product-card__atc, .quantity, .wishlist-element, [data-wim-df-actions], form, .see-price, [data-wim-df-see-price], .wim-dfd-wishlist-btn'
      );
      if (!isInteractive) {
        var targetLink = card.getAttribute('dfd-value-link') ||
          (card.querySelector('[dfd-value-link]') && card.querySelector('[dfd-value-link]').getAttribute('dfd-value-link')) ||
          (card.querySelector('a.dfd-card-link') && card.querySelector('a.dfd-card-link').getAttribute('href')) ||
          (card.querySelector('a[href*="/products/"]') && card.querySelector('a[href*="/products/"]').getAttribute('href'));
        if (targetLink) {
          try {
            var urlObj = new URL(targetLink, window.location.origin);
            targetLink = urlObj.pathname + urlObj.search + urlObj.hash;
          } catch (err) {
            targetLink = targetLink.replace(/^https?:\/\/[^\/]+/, '');
          }
          window.location.href = targetLink;
        }
      }
    }
  });

  window.WimDoofinderPricing = window.WimDoofinderPricing || {};
  window.WimDoofinderPricing.refresh = handleDoofinderUpdate;

  // WIM: Calcular dinámicamente la posición inferior exacta del header para alinear Doofinder
  function updateDoofinderTopPosition() {
    if (window.innerWidth < 768) return;
    var menuBottom = document.querySelector('.header__bottom');
    var header = menuBottom && window.getComputedStyle(menuBottom).display !== 'none'
      ? menuBottom
      : document.querySelector('header.header') || document.querySelector('.header-section');
    if (header) {
      var rect = header.getBoundingClientRect();
      var topPos = Math.round(rect.bottom);
      if (topPos > 0) {
        document.documentElement.style.setProperty('--wim-doofinder-top', topPos + 'px');
      }
    }
  }
  window.addEventListener('resize', updateDoofinderTopPosition, { passive: true });
  window.addEventListener('scroll', updateDoofinderTopPosition, { passive: true });

  // WIM: Bloquear scroll del fondo en desktop sin tocar overflow de body para no romper position: sticky
  function preventBodyScrollWhenDoofinderOpen(e) {
    if (document.body.classList.contains('wim-doofinder-open') && window.innerWidth >= 768) {
      if (!e.target.closest('.dfd-root, #df-layer-wrapper, .df-layer, [data-dfd-screen], .dfd-layer')) {
        e.preventDefault();
      }
    }
  }
  window.addEventListener('wheel', preventBodyScrollWhenDoofinderOpen, { passive: false });
  window.addEventListener('touchmove', preventBodyScrollWhenDoofinderOpen, { passive: false });

  ['pointerdown', 'focusin', 'click'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (window.innerWidth < 768) return;
      if (e.target && e.target.closest && e.target.closest('.search__input, [data-dfd-role="searchbox"], input[type="search"], .header__search')) {
        document.body.classList.add('wim-doofinder-open');
        document.body.classList.add('header-pinned');
        document.documentElement.classList.add('wim-doofinder-open');
        updateDoofinderTopPosition();
      }
    }, true);
  });

  document.addEventListener('click', function (e) {
    if (document.body.classList.contains('wim-doofinder-open')) {
      if (e.target.closest('.header-section .fixed-overlay')) {
        var closeBtn = document.querySelector('.dfd-close-button, [class*="close-button"], [dfd-click*="close"], .dfd-close');
        if (closeBtn) {
          closeBtn.click();
        } else if (window.location.hash && window.location.hash.includes('classic')) {
          history.pushState('', document.title, window.location.pathname + window.location.search);
          window.dispatchEvent(new Event('hashchange'));
        }
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('wim-doofinder-open')) {
      var closeBtn = document.querySelector('.dfd-close-button, [class*="close-button"], [dfd-click*="close"], .dfd-close');
      if (closeBtn) {
        closeBtn.click();
      }
    }
  });

  // WIM: Watcher robusto que evita parpadeo y respeta mobile
  setInterval(function () {
    if (window.innerWidth < 768) {
      if (document.body.classList.contains('wim-doofinder-open')) {
        document.body.classList.remove('wim-doofinder-open');
        document.documentElement.classList.remove('wim-doofinder-open');
      }
      return;
    }

    var dfLayer = document.querySelector('.dfd-root, #df-layer-wrapper, .df-layer, #doofinder-layer');
    var isInputFocused = document.activeElement && document.activeElement.closest && document.activeElement.closest('.search__input, [data-dfd-role="searchbox"], input[type="search"]');
    var isHashClassic = window.location.hash && window.location.hash.includes('classic');

    var isLayerVisible = false;
    if (dfLayer) {
      var display = window.getComputedStyle(dfLayer).display;
      var visibility = window.getComputedStyle(dfLayer).visibility;
      isLayerVisible = (display !== 'none' && visibility !== 'hidden');
    }

    if (isLayerVisible || isHashClassic || isInputFocused) {
      if (!document.body.classList.contains('wim-doofinder-open')) {
        document.body.classList.add('wim-doofinder-open');
        document.body.classList.add('header-pinned');
        document.documentElement.classList.add('wim-doofinder-open');
      }
      updateDoofinderTopPosition();
    } else {
      if (document.body.classList.contains('wim-doofinder-open')) {
        document.body.classList.remove('wim-doofinder-open');
        document.documentElement.classList.remove('wim-doofinder-open');
        // Mantener header-pinned para que la cabecera permanezca visible al cerrar Doofinder
        document.body.classList.add('header-pinned');
      }
    }
  }, 250);

})();
